module.exports = __webpack_public_path__ + "img/57.fe913033.jpg";